<template>
  <div class="search-panel">
    <kcs-facility-total :total="total" v-if="isHome" />
    <form @submit.prevent="onSubmit">
      <div class="main-search-box">
        <div class="select-wrapper">
          <kcs-select
            v-model="dataPrefecture"
            :options="prefectures"
            name="pref"
          />
        </div>
        <div class="select-wrapper">
          <kcs-select v-model="dataCity" :options="cityList" name="city" />
        </div>
        <div class="select-wrapper">
          <kcs-select
            v-model="dataEventType"
            :options="eventTypes"
            name="eventType"
          />
        </div>
        <div class="text-wrapper">
          <kcs-input
            v-model="dataKeyword"
            name="keyword"
            placeholder="フリーワード"
          />
        </div>
        <div class="facility-wrapper checkbox-wrapper">
          <kcs-ul-checkbox
            v-model="dataService"
            :options="services"
            name="service"
          />
        </div>
        <kcs-search-button
          @click.native="
            handleAnalyticsTrackEvent('search', 'submit', 'navi', 1)
          "
          name="検索する"
        />
      </div>
    </form>
    <ul v-if="!isHome" class="offcanvas-link">
      <li>
        <nuxt-link @click.native="toggle" to="/s/">
          セミナー会場を探す
        </nuxt-link>
      </li>
      <li>
        <nuxt-link @click.native="toggle" to="/summary/">
          イベント会場まとめ
        </nuxt-link>
      </li>
      <li>
        <nuxt-link @click.native="toggle" to="/station/">
          駅・路線から探す
        </nuxt-link>
      </li>
      <li>
        <a href="/request/" target="_blank">
          掲載リクエストフォーム
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { createUrl } from '@/utils/create-url'
import { methods } from '@/utils/methods'
import KcsFacilityTotal from '@/components/molecules/kcs-facility-total.vue'
import KcsInput from '@/components/atoms/kcs-input.vue'
import KcsSelect from '@/components/atoms/kcs-select.vue'
import kcsUlCheckbox from '@/components/atoms/kcs-ul-checkbox.vue'
import KcsSearchButton from '@/components/atoms/kcs-search-button.vue'
export default {
  components: {
    KcsFacilityTotal,
    KcsInput,
    KcsSelect,
    kcsUlCheckbox,
    KcsSearchButton
  },
  props: {
    isHome: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dataPrefecture: '',
      dataCity: '',
      dataEventType: '',
      dataService: [],
      dataKeyword: ''
    }
  },
  computed: {
    ...mapGetters({
      query: 'search_condition/query',
      cityList: 'facility/cityList'
    }),
    prefectures() {
      const prefectureList = methods.getPrefectureList()
      // 配列の最初に追加
      prefectureList.unshift({ name: '都道府県', value: '' })
      return prefectureList
    },
    eventTypes() {
      // 開催イベントの規模の配列を生成
      const facilityEventTypesList = methods.getFacilityEventTypesList()
      // 配列の最初に追加
      facilityEventTypesList.unshift({ name: '開催イベントの規模', value: '' })
      return facilityEventTypesList
    },
    services() {
      // 設備・サービスの配列を生成
      return methods.getServiceList()
    },
    isToppage() {
      return this.$route.path === '/'
    }
  },
  watch: {
    // 都道府県が変更されたら、市区町村を変更する
    async dataPrefecture(value) {
      if (!value || this.query.prefecture !== value) {
        // 都道府県から市区町村リストを取得
        await this.getCityList(value)
        // cityListの中に、選択中の市区町村が含まれていないなら、初期化
        if (!this.cityList.some((data) => data.name === this.dataCity)) {
          this.dataCity = ''
        }
      }
    },
    /* istanbul ignore next */
    $route(to, from) {
      // パラメーター変更を検知して、data変数を最新化
      this.setData()
    }
  },
  mounted() {
    this.setData()
  },
  methods: {
    ...mapActions({
      getCityList: 'facility/cityList',
      resetSearchCondition: 'search_condition/reset'
    }),
    onSubmit() {
      this.toggle()
      this.$router.push(
        createUrl.createSearchUrl({
          prefecture: this.dataPrefecture,
          city: this.dataCity,
          // イベントタイプを配列に変更する
          eventType: [this.dataEventType],
          service: this.dataService,
          keyword: this.dataKeyword
        })
      )
    },
    async setData() {
      // トップページ表示時は、検索パラメータをリセットする
      if (this.isToppage) {
        this.resetSearchCondition()
      }

      if (this.isHome) {
        // トップページの検索メニューはストアを参照しないため、
        // 市区町村リストの初期値だけセットする
        await this.getCityList()
      } else {
        // スマホ用サイドメニューはストアを参照するため、
        // queryの値をセットする
        this.dataPrefecture = this.query.prefecture
        this.dataCity = this.query.city
        // イベントタイプの1つ目をセット
        this.dataEventType = this.query.eventType[0]
        this.dataService = this.query.service
        this.dataKeyword = this.query.keyword

        await this.getCityList(this.query.prefecture)
      }
    },
    toggle() {
      this.$emit('toggle')
    }
  }
}
</script>
